/* eslint-disable */
import { Table, DatePicker, Select, Flex, Radio, Button, message } from "antd";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import commonFn from "@/utils/commonFn";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import { render } from "@testing-library/react";
import { SyncOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;

const MaintenceMain = forwardRef(() => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [tableoading, setTableLoading] = useState(false);
  const [selectedValues, setSelectedValues] = useState(null);
  const [reportList, setReportList] = useState([]);
  const originalReportList = useRef([]);
  const [currentReportList, setCurrentReportList] = useState(reportList);
  const [assignedDates, setAssignedDates] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);

  const handlQuotedCountClick = (record) => {
    // console.log(record);
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Quoted"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlRequestCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Assigned"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlSupervisorClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Requests Under Supervisor"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlRequestOutstandingClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Total Outstanding Requests"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const handlApprovedClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Approved"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlReviewCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Review"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlCompletedCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Completed"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  //
  const handlCompletedInvoicedCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Completed Invoiced"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlCompletedNoInvoicedCountClick = (record) => {
    const quotedStatus = record.statusList?.find(
      (item) => item.statusName === "Completed No Invoiced"
    );
    if (
      !quotedStatus ||
      quotedStatus.count === 0 ||
      quotedStatus.count === "0"
    ) {
      return;
    }
    const params = { ids: quotedStatus.maintenanceIdList.join(",") };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  // 转义
  const formatCount = (count) => {
    if (count === null || count === undefined) return "-";
    return Number(count) === 0 ? "-" : count;
  };
  // 通用函数处理

  const initColumns = [
    {
      title: "Supervisor Name",
      dataIndex: "accountName",
      key: "accountName",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) => ({
        children: record.isSummaryRow ? (
          <strong style={{ fontSize: "16px" }}>{text}</strong>
        ) : (
          text
        ),
        props: {
          rowSpan: record.isFirstRow ? record.rowSpan : 0,
        },
      }),
    },

    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      key: "vendorName",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) => ({
        children:
          record.vendorName === "Grand Total" ? (
            <strong style={{ fontSize: "16px" }}>{text}</strong>
          ) : record.vendorName === "Total" ? (
            <strong>{text}</strong>
          ) : (
            text
          ),
      }),
    },
    {
      title: "Total Outstanding Requests",
      dataIndex: "Total Outstanding Requests",
      key: "Total Outstanding Requests",
      hidden: false,
      width: 100,
      align: "center",
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Total Outstanding Requests"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() =>
              value !== "-" && handlRequestOutstandingClick(record)
            }
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Total Requests Under Supervisor",
      dataIndex: "Total Requests Under Supervisor",
      key: "Total Requests Under Supervisor",
      hidden: false,
      width: 100,
      align: "center",
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Total Requests Under Supervisor"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlSupervisorClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Total Assigned",
      dataIndex: "Assigned",
      key: "Assigned",
      hidden: false,
      width: 100,
      align: "center",
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Assigned"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlRequestCountClick(record)}
          >
            {value}
          </span>
        );
      },
    },

    {
      title: "Total Quoted",
      dataIndex: "Quoted",
      key: "Quoted",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (item) => item.statusName === "Quoted"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlQuotedCountClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Total Approved To Work",
      dataIndex: "Approved",
      key: "Approved",
      hidden: false,
      width: 100,
      align: "center",
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Approved"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlApprovedClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Need Management Review",
      dataIndex: "Review",
      key: "Review",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Review"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlReviewCountClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Total Completed Jobs",
      dataIndex: "Completed",
      key: "Completed",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Completed"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() => value !== "-" && handlCompletedCountClick(record)}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Average Job Completed(Days)",
      dataIndex: "Average Job Completed",
      key: "Average Job Completed",
      width: 150,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Average Job Completed"
        );

        // 判断 maintenanceIdList 是否为空数组或不存在
        if (
          !status?.maintenanceIdList ||
          status.maintenanceIdList.length === 0
        ) {
          return <span>-</span>;
        }

        return <span>{status.count}</span>;
      },
    },
    {
      title: "Average Delay due to Management Approval (Days)",
      dataIndex: "Average Delay due to Management Approval",
      key: "Average Delay due to Management Approval",
      width: 150,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Average Delay due to Management Approval"
        );

        // 判断 maintenanceIdList 是否为空数组或不存在
        if (
          !status?.maintenanceIdList ||
          status.maintenanceIdList.length === 0
        ) {
          return <span>-</span>;
        }

        return <span>{status.count}</span>;
      },
    },
    {
      title: "Completed Invoiced",
      dataIndex: "Completed Invoiced",
      key: "Completed Invoiced",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Completed Invoiced"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() =>
              value !== "-" && handlCompletedInvoicedCountClick(record)
            }
          >
            {value}
          </span>
        );
      },
    },
    {
      title: "Completed No Invoiced",
      dataIndex: "Completed No Invoiced",
      key: "Completed No Invoiced",
      hidden: false,
      width: 100,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (_, record) => {
        const status = record.statusList?.find(
          (s) => s.statusName === "Completed No Invoiced"
        );
        const value = formatCount(status?.count);
        return (
          <span
            style={{
              color: value === "-" ? "inherit" : "#0e78a9",
              cursor: value === "-" ? "default" : "pointer",
            }}
            onClick={() =>
              value !== "-" && handlCompletedNoInvoicedCountClick(record)
            }
          >
            {value}
          </span>
        );
      },
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 获取所有的report

  const reportAllData = async (accountIds) => {
    try {
      setTableLoading(true);
      const params = {
        accountIdList: Array.isArray(accountIds)
          ? accountIds.join(",")
          : accountIds || "",
      };
      const queryString = new URLSearchParams(params).toString();
      const url = `${api.getMaintenanceVendorReport}?${queryString}`;
      const response = await http.get(url);

      let flattenedData = [];
      response.data?.forEach((supervisor) => {
        const isAllSupervisor = supervisor.accountName === "All Supervisor";
        // 处理 All Supervisor 行（不合并）
        if (isAllSupervisor) {
          supervisor.vendorReports.forEach((vendor) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: true,
              rowSpan: 1,
              isSummaryRow: true, // 标记为汇总行
              key: `summary-${vendor.vendorName || Date.now()}`,
            });
          });
        }
        // 处理其他 supervisor 数据
        else {
          const validVendors = supervisor.vendorReports.filter(
            (v) => v.vendorName !== "Grand Total"
          );

          // 添加常规 vendor 数据（合并 accountName）
          validVendors.forEach((vendor, index) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: index === 0,
              rowSpan: index === 0 ? validVendors.length : 0,
              isSummaryRow: false,
              key: `${supervisor.accountId}-${vendor.vendorName || index}`,
            });
          });
        }
      });

      setFilteredData(flattenedData);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };

  // 下拉选择
  const onSupervisorChange = (value) => {
    setSelectedSupervisor(value);
  };
  // submit
  const handleSubmit = async () => {
    if (!selectedSupervisor) {
      message.error("Supervisor is required!");
      return;
    }

    const params = {
      accountIdList: selectedSupervisor,
    };
    if (assignedDates && assignedDates.length === 2) {
      params.sTime = assignedDates[0].valueOf();
      params.eTime = assignedDates[1].valueOf();
    }

    console.log("提交参数:", params);

    try {
      setTableLoading(true);
      setFilteredData([]);  //清空 表格数据
      const queryString = new URLSearchParams(params).toString();
      const url = `${api.getMaintenanceVendorReport}?${queryString}`;
      const response = await http.get(url);
      let flattenedData = [];
      response.data?.forEach((supervisor) => {
        const isAllSupervisor = supervisor.accountName === "All Supervisor";
        // 处理 All Supervisor 行（不合并）
        if (isAllSupervisor) {
          supervisor.vendorReports.forEach((vendor) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: true,
              rowSpan: 1,
              isSummaryRow: true, // 标记为汇总行
              key: `summary-${vendor.vendorName || Date.now()}`,
            });
          });
        }
        // 处理其他 supervisor 数据
        else {
          const validVendors = supervisor.vendorReports.filter(
            (v) => v.vendorName !== "Grand Total"
          );

          // 添加常规 vendor 数据（合并 accountName）
          validVendors.forEach((vendor, index) => {
            flattenedData.push({
              ...supervisor,
              ...vendor,
              isFirstRow: index === 0,
              rowSpan: index === 0 ? validVendors.length : 0,
              isSummaryRow: false,
              key: `${supervisor.accountId}-${vendor.vendorName || index}`,
            });
          });
        }
      });

      setFilteredData(flattenedData);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  const getSupervisorList = async () => {
    try {
      const response = await http.get(api.getSupervisorList);
      console.log("response", response);
      if (response.code === "1") {
        const options = [
          { value: "", label: "All" },
          ...response.data.map((item) => ({
            value: item.accountId,
            label: item.fullName,
          })),
        ];
        setReportList(options);
        originalReportList.current = options;
        setCurrentReportList(options);
      }
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    }
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    reportAllData();
    setSelectedValues([]);
  };
  // 初始化函数

  useEffect(() => {
    // reportAllData()
    getSupervisorList();
  }, []);
  return (
    <div>

      <Flex className="topDiv" justify="space-between" align="center">
        {/* 左边筛选条件 */}
        <Flex align="center" gap={12}>
          <div>
            <span style={{ marginRight: 8 }}>Supervisor:</span>
            <Select
              mode="multiple"
              showSearch
              allowClear
              placeholder="Select a supervisor"
              value={selectedSupervisor}
              onChange={onSupervisorChange}
              style={{ width: 380,textAlign: "left"}}
              options={currentReportList}
              className="supervisor-select"
            />
          </div>

          <div>
            <span style={{ marginRight: 8 }}>Assigned Date:</span>
            <RangePicker
              allowClear
              format="MM/DD/YYYY"
              value={assignedDates}
              onChange={(dates) => setAssignedDates(dates)}
            />
          </div>

          <Button type="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Flex>

        {/* 右边刷新按钮 */}
        <Radio.Group defaultValue="a" size="middle">
          <Radio.Button value="a" onClick={showModalThree}>
            <SyncOutlined />
          </Radio.Button>
        </Radio.Group>
      </Flex>
      <Table
        rowClassName="table-row-gradient"
        loading={tableoading}
        bordered={true}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={false}
        rowKey="accountId"
        scroll={{
          x: "max-content",
          y: "calc(100vh - 350px)",
        }}
        className="maintenance-report-Table"
      />
    </div>
  );
});
export default MaintenceMain;
